"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const getContentType_1 = require("../../helpers/getContentType");
const entity_1 = require("../../type/entity");
const applyAdminAssignCurriculum_1 = require("./applyAdminAssignCurriculum");
const applyAdminAssignOffer_1 = require("./applyAdminAssignOffer");
const applyAssignCheckpoint_1 = require("./applyAssignCheckpoint");
const applyAssignCurriculum_1 = require("./applyAssignCurriculum");
const applyAssignILT_1 = require("./applyAssignILT");
const applyAssignOffer_1 = require("./applyAssignOffer");
function assignCurriculumChildContents(command, childContentIds, contents, user, states, enrolments, stateInteractions) {
    const childContents = [];
    const events = [];
    let updatedStateInteractions = stateInteractions;
    let updatedStates = states;
    let updatedEnrolments = enrolments;
    const childrenContentsById = keyBy_1.default(contents, '_id');
    childContentIds.forEach((curriculumChildContentId) => {
        const content = childrenContentsById[curriculumChildContentId];
        const applyPayload = applyAssignContent(command, user, content, childContents, updatedStates, updatedEnrolments, updatedStateInteractions);
        updatedStates = applyPayload.states;
        updatedEnrolments = applyPayload.enrolments;
        updatedStateInteractions = applyPayload.stateInteractions;
        events.push(...applyPayload.events);
    });
    return { events, states: updatedStates, stateInteractions, enrolments: updatedEnrolments };
}
exports.assignCurriculumChildContents = assignCurriculumChildContents;
function applyAssignContent(command, user, content, childrenContents, states, enrolments, stateInteractions) {
    const contentType = getContentType_1.getContentType(content);
    const fromAdmin = command.fromAdmin;
    switch (contentType) {
        case entity_1.ContentType.COURSE: {
            if (fromAdmin) {
                return applyAdminAssignOffer_1.applyAdminAssignOffer(command, user, content, states, enrolments, stateInteractions);
            }
            return applyAssignOffer_1.applyAssignOffer(command, user, content, states, enrolments, stateInteractions);
        }
        case entity_1.ContentType.CURRICULUM: {
            const curriculumChildContentIds = content.offers.map((offer) => offer.offerId);
            let updatedStates = states;
            let updatedEnrolments = enrolments;
            let updatedStateInteractions = stateInteractions;
            const events = [];
            const childAssignPayload = assignCurriculumChildContents(command, curriculumChildContentIds, childrenContents, user, updatedStates, updatedEnrolments, updatedStateInteractions);
            updatedStates = childAssignPayload.states;
            updatedEnrolments = childAssignPayload.enrolments;
            updatedStateInteractions = childAssignPayload.stateInteractions;
            events.push(...childAssignPayload.events);
            let applyCurriculumPayload;
            if (fromAdmin) {
                applyCurriculumPayload = applyAdminAssignCurriculum_1.applyAdminAssignCurriculum(command, user, content, updatedStates, updatedEnrolments, updatedStateInteractions);
            }
            else {
                applyCurriculumPayload = applyAssignCurriculum_1.applyAssignCurriculum(command, user, content, updatedStates, updatedEnrolments, stateInteractions);
            }
            updatedStates = applyCurriculumPayload.states;
            updatedEnrolments = applyCurriculumPayload.enrolments;
            updatedStateInteractions = applyCurriculumPayload.stateInteractions;
            events.push(...applyCurriculumPayload.events);
            return {
                events,
                states: updatedStates,
                stateInteractions: updatedStateInteractions,
                enrolments: updatedEnrolments
            };
        }
        case entity_1.ContentType.CHECKPOINT: {
            return applyAssignCheckpoint_1.applyAssignCheckpoint(command, user, content, states, enrolments, stateInteractions);
        }
        case entity_1.ContentType.ILT: {
            return applyAssignILT_1.applyAssignILT(command, user, content, states, enrolments, stateInteractions);
        }
        default:
            return { events: [], states, stateInteractions, enrolments };
    }
}
exports.applyAssignContent = applyAssignContent;
//# sourceMappingURL=index.js.map